/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { OocvTableFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { OocvTableFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';

export const oocvTableDataMock: OocvTableFragmentFragment = {
  headline: 'Sohle',
  rows: [
    {
      key: 'Dämpfungstechnologien',
      value: 'Max Air',
    },
    {
      key: 'Laufsohlenmaterial',
      value: 'Gummi',
    },
    {
      key: 'Laufsohlenprofil',
      value: 'leicht profiliert',
    },
  ],
};

export function getOocvTableFragmentedData(data?: OocvTableFragmentFragment) {
  return makeFragmentData(data || oocvTableDataMock, OocvTableFragmentFragmentDoc);
}
